"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputLabel = void 0;

var _stylitas = require("@creditas/stylitas");

var _inputLabel = require("./inputLabel.style");

const InputLabel = _stylitas.styled.label`
  ${_inputLabel.inputLabelBase};
  ${_inputLabel.inputLabelHover};
  ${_inputLabel.inputLabelFocused};
  ${_inputLabel.inputLabelShrink};
  ${_inputLabel.inputLabelDisabled};
  ${_inputLabel.inputLabelReadOnly};
  ${_inputLabel.inputLabelDefaultDensity};
  ${_inputLabel.inputLabelComfortableDensity};
  ${_inputLabel.inputLabelCompactDensity};
  ${_inputLabel.inputLabelTransformDefault};
  ${_inputLabel.inputLabelTransformComfortable};
  ${_inputLabel.inputLabelTransformCompact};
  ${_inputLabel.leftPositionOnFocus};
  ${_inputLabel.positionOnFocusDefault};
  ${_inputLabel.positionOnFocusComfortable};
  ${_inputLabel.positionOnFocusCompact};
`;
exports.InputLabel = InputLabel;
InputLabel.displayName = 'InputLabel';